import { createContext, useState } from "react";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";

import {
  changeProductActiveServices,
  createProductsAdminService,
  editProductAdminServices,
  getProductsAdminService,
} from "../../../services/userServices";
import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "../../../redux/actions/loadingActions/loadingActions";

export const productsAdminContext = createContext({
  getProducts: [],
  setGetProducts: () => {},
  addProduct: null,
  setAddProduct: () => {},
  active: null,
  setActive: () => {},
  editProductId: "",
  setEditProductId: () => {},
  editProductData: "",
  setEditProductData: () => {},
  buyTolerance: "",
  setBuyTolerance: () => {},
  sellTolerance: "",
  setSellTolerance: () => {},
  buyCalculate: "",
  setBuyCalculate: () => {},
  sellCalculate: "",
  setSellCalculate: () => {},
  balance: "",
  setBalance: () => {},
  handleCreateProductAdmin: () => {},
  handleGetProductsAdmin: () => {},
  handleOpenEditModal: () => {},
  handleCloseEditModal: () => {},
  handleEditProductAdmin: () => {},
  handleChangePriorityProduct: () => {},
  handleChangeActiveProduct: () => {},
  //* Product Information
  productInfoId: "",
  setProductInfoId: () => {},
  productInfoData: [],
  setProductInfoData: () => {},
  handleOpenProductInfo: () => {},
  handleCloseProductInfo: () => {},
});

const ProductsAdminContext = ({ children }) => {
  const dispatch = useDispatch();
  const [getProducts, setGetProducts] = useState([]);
  const [addProduct, setAddProduct] = useState(false);
  const [editProductId, setEditProductId] = useState("");
  const [editProductData, setEditProductData] = useState([]);

  const [buyTolerance, setBuyTolerance] = useState(5000);
  const [sellTolerance, setSellTolerance] = useState(5000);
  const [buyCalculate, setBuyCalculate] = useState("*1/1+0-0");
  const [sellCalculate, setSellCalculate] = useState("*1/1+0-0");
  const [balance, setBalance] = useState(0);

  const [productInfoId, setProductInfoId] = useState("");
  const [productInfoData, setProductInfoData] = useState([]);

  //! Create Product Start
  //* Handle Create Product Admin
  const handleCreateProductAdmin = async (userData) => {
    const objData = {
      ...userData,
      buyCalculate,
      sellCalculate,
      buy_price: Number(userData.buy_price),
      sell_price: Number(userData.sell_price),
      balance: isNaN(Number(userData.balance)) ? Number(balance) : 0,
      buyTolerance: isNaN(Number(userData.buyTolerance))
        ? Number(buyTolerance)
        : 5000,
      sellTolerance: isNaN(Number(userData.sellTolerance))
        ? Number(sellTolerance)
        : 5000,
      related_product: userData.related_product
        ? Number(userData.related_product)
        : null,
      hesabiProductId: Number(userData.hesabiProductId),
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await createProductsAdminService(objData);
      if (status === 200) {
        setAddProduct(false);
        handleGetProductsAdmin();
        setBuyTolerance("");
        setSellTolerance("");
        setBuyCalculate("");
        setSellCalculate("");
        setBalance("");
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toast.error(response.data.message);
        }
      }
      dispatch(setLoadingFalseAction());
    }
  };

  const handleChangeBuyTolerance = (event) => {
    setBuyTolerance(event.target.value);
  };
  const handleChangeSellTolerance = (event) => {
    setSellTolerance(event.target.value);
  };
  const handleChangeBuyCalculate = (event) => {
    setBuyCalculate(event.target.value);
  };
  const handleChangeSellCalculate = (event) => {
    setSellCalculate(event.target.value);
  };
  const handleChangeBalance = (event) => {
    setBalance(event.target.value);
  };

  //* Set Default Value In States When Open Modal
  const defaultValuesCreateProduct = {
    buyTolerance: 5000,
    sellTolerance: 5000,
    buyCalculate: "*1/1+0-0",
    sellCalculate: "*1/1+0-0",
    balance: 0,
  };

  //* Handle Open Create Modal And Save Default Value In States
  const handleOpenCreateModal = () => {
    setBuyTolerance(defaultValuesCreateProduct.buyTolerance);
    setSellTolerance(defaultValuesCreateProduct.sellTolerance);
    setBuyCalculate(defaultValuesCreateProduct.buyCalculate);
    setSellCalculate(defaultValuesCreateProduct.sellCalculate);
    setBalance(defaultValuesCreateProduct.balance);

    setAddProduct(true);
  };
  //! Create Product End

  //* Handle Get Products Admin
  const handleGetProductsAdmin = async () => {
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getProductsAdminService();
      if (status === 200) {
        setGetProducts(data);
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toast.error(response.data.message);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  //! Edit Product Start
  //* Handle Edit Product Admin
  const handleOpenEditModal = (_item, setValue) => {
    if (!_item) {
      setEditProductId("");
      return;
    }
    setEditProductId(_item?.id);
    setEditProductData(_item);

    setValue("id", _item?.id);
    setValue("name", _item?.name);
    setValue("related_product", _item?.related_product_id);
    setValue("buy_price", _item?.buy_price);
    setValue("sell_price", _item?.sell_price);
    setValue("buy_calculation", _item?.buy_calculation);
    setValue("sell_calculation", _item?.sell_calculation);
    setValue("balance", _item?.balance);
    setValue("is_market_close", _item?.is_market_close);
    setValue("tag", _item?.tag);
    setValue("b_tel", _item?.b_tel);
    setValue("s_tel", _item?.s_tel);
    setValue("hesabiProductId", _item?.hesabiProductId);
    setValue("is_sell_closed", _item?.is_sell_closed);
    setValue("is_buy_closed", _item?.is_buy_closed);
  };

  const handleCloseEditModal = () => {
    setEditProductId("");
  };

  const handleEditProductAdmin = async (userData) => {
    const objData = {
      ...userData,
      buy_price: Number(userData?.buy_price),
      sell_price: Number(userData?.sell_price),
      balance: Number(userData?.balance),
      b_tel: Number(userData?.b_tel),
      s_tel: Number(userData?.s_tel),
      related_product: userData?.related_product
        ? Number(userData?.related_product)
        : null,
      hesabiProductId: Number(userData?.hesabiProductId),
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await editProductAdminServices(objData);
      if (status === 200) {
        handleCloseEditModal();
        handleGetProductsAdmin();
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toast.error(response.data.message);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };
  //! Edit Product End

  //* Change Priority Product
  const handleChangePriorityProduct = async (
    id,
    periority,
    is_sell_closed,
    is_buy_closed,
    is_market_close
  ) => {
    const objData = {
      id,
      periority,
      is_sell_closed,
      is_buy_closed,
      is_market_close,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await changeProductActiveServices(objData);
      if (status === 200) {
        handleGetProductsAdmin();
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toast.error(response.data.message);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  //* Change Active Product
  const handleChangeActiveProduct = async (
    id,
    is_market_close,
    periority,
    is_sell_closed,
    is_buy_closed
  ) => {
    const objData = {
      id,
      is_market_close,
      periority,
      is_sell_closed,
      is_buy_closed,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await changeProductActiveServices(objData);
      if (status === 200) {
        handleGetProductsAdmin();
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toast.error(response.data.message);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  //! Product Information Start
  const handleOpenProductInfo = (productInfo) => {
    setProductInfoId(productInfo.id);
    setProductInfoData(productInfo);
  };

  const handleCloseProductInfo = () => {
    setProductInfoId("");
  };
  //! Product Information End

  return (
    <productsAdminContext.Provider
      value={{
        getProducts,
        setGetProducts,
        addProduct,
        setAddProduct,
        editProductId,
        setEditProductId,
        editProductData,
        setEditProductData,
        buyTolerance,
        setBuyTolerance,
        sellTolerance,
        setSellTolerance,
        buyCalculate,
        setBuyCalculate,
        sellCalculate,
        setSellCalculate,
        balance,
        setBalance,
        handleCreateProductAdmin,
        handleGetProductsAdmin,
        handleOpenEditModal,
        handleCloseEditModal,
        handleEditProductAdmin,
        handleChangePriorityProduct,
        handleChangeActiveProduct,
        handleOpenCreateModal,
        handleChangeBuyTolerance,
        handleChangeSellTolerance,
        handleChangeBuyCalculate,
        handleChangeSellCalculate,
        handleChangeBalance,
        //* Product Information
        productInfoId,
        setProductInfoId,
        productInfoData,
        setProductInfoData,
        handleOpenProductInfo,
        handleCloseProductInfo,
      }}
    >
      {children}
    </productsAdminContext.Provider>
  );
};

export default ProductsAdminContext;
